import React from 'react';
import Table from '../Table';
import { TipDetail } from 'model/TipsReport';
import { reduceResolution, wbp } from 'Theme';
import { Box, TableCell, TableRow } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useCommonStyles as useTableStyles } from '../Table/CommonStyles';
import { InvoiceNumberLink } from '../InvoiceNumberLink';

interface TipsDetailTableProps {
    loading: boolean;
    tipsDetail?: Array<TipDetail> | null;
    onOpenInvoice?: (invoiceId: number, marketplaceId: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingTop: 8,

            [theme.breakpoints.down('sm')]: {
                backgroundColor: '#FAFAFA'
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: 16,
                margin: '0px -24px'
            }
        },
        header: {
            [theme.breakpoints.down(wbp)]: {
                paddingBottom: `${reduceResolution(63)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingBottom: '63px'
            }
        },
        cell: {
            fontWeight: 400,
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '15px'
            }
        },
        cellHeader: {
            padding: '20px 0px'
        }
    })
);

// Refunded tips show as negative, the same way refunds appear in the transaction reports.
const refundedLabel = (amount: string): string => (Number(amount) > 0 ? `-$${amount}` : '');

export const TipsDetailTable: React.FunctionComponent<TipsDetailTableProps> = props => {
    const classes = useStyles();
    const tableStyles = useTableStyles();

    const headersTipsDetail = (
        <>
            <TableCell className={tableStyles.headerCell}>Date</TableCell>
            <TableCell className={tableStyles.headerCell}>Invoice</TableCell>
            <TableCell className={tableStyles.headerCell}>Customer</TableCell>
            <TableCell className={tableStyles.headerCell}>Staff</TableCell>
            <TableCell className={tableStyles.headerCell}>Tip</TableCell>
            <TableCell className={tableStyles.headerCell}>Refunded</TableCell>
        </>
    );

    const rowsTipsDetail = (
        <>
            {props.tipsDetail?.map(tipsDetail => {
                return (
                    <>
                        <TableRow>
                            <TableCell className={tableStyles.cell}>{tipsDetail.createdAt}</TableCell>
                            <TableCell className={tableStyles.cell}>
                                <InvoiceNumberLink
                                    invoiceId={tipsDetail.invoiceId}
                                    invoiceNumber={tipsDetail.invoiceNumber}
                                    onClick={invoiceId => props.onOpenInvoice?.(invoiceId, tipsDetail.marketplaceId)}
                                />
                            </TableCell>
                            <TableCell className={tableStyles.cell}>{tipsDetail.customerName}</TableCell>
                            <TableCell className={tableStyles.cell}>{tipsDetail.staffName}</TableCell>
                            <TableCell className={tableStyles.cell}>{`$${tipsDetail.amount}`}</TableCell>
                            <TableCell className={tableStyles.cell}>
                                {refundedLabel(tipsDetail.refundedAmount)}
                            </TableCell>
                        </TableRow>
                    </>
                );
            })}
        </>
    );

    return (
        <Box className={classes.root}>
            <Table
                headers={headersTipsDetail}
                rows={props.tipsDetail ? rowsTipsDetail : <></>}
                loading={props.loading}
                withoutColor={true}
            />
        </Box>
    );
};

export default TipsDetailTable;
